module.exports = __webpack_public_path__ + "static/media/star_empty.9b2fd062.svg";